module.exports = __webpack_public_path__ + "img/business.a2f96e24.png";